import { TextField, Typography } from "@mui/material";
import "./TextInput.css";

const TextInput = (props) => {
    const {
        name, label, subtitle, register, error,
        multiline, minRows,
        placeholder, disabled,
        value, onChange,
        helperTextRequired = true,
    } = props;

    const additionalProps = register ? register(name) : {};

    return (
        <TextField
            id={name}
            name={name}
            label={subtitle ? (
                <>
                    <label htmlFor={name}>{label}</label>
                    {subtitle && <Typography variant="subtitle2">{subtitle}</Typography>}
                </>
            ) : label}
            variant="outlined"
            value={value}
            onChange={onChange}
            {...additionalProps}
            inputRef={additionalProps?.ref}
            error={!!error}
            helperText={helperTextRequired ? error : ""}
            placeholder={placeholder}
            disabled={disabled}
            slotProps={{ inputLabel: { shrink: true } }}
            className="text-field"
            multiline={multiline}
            minRows={multiline ? (minRows || 4) : undefined}
        />
    );
};

export default TextInput;
